export type ErrorColor =
  | 'error'
  | 'error-light';

export type WarningColor =
  | 'warning'
  | 'warning-light';

type SuccessColor =
  | 'success'
  | 'success-light';

export type IconColor =
  | 'selected'
  | 'disabled'
  | ErrorColor
  | WarningColor
  | SuccessColor
  | 'action'
  | 'action-light'
  | 'regular'
  | 'forbidden';

export type SchemeColor =
  | 'scheme-feedback-action-color'
  | 'scheme-feedback-action-light-color'
  | 'scheme-feedback-error-color'
  | 'scheme-feedback-error-light-color'
  | 'scheme-feedback-success-color'
  | 'scheme-feedback-success-light-color'
  | 'scheme-feedback-text-color'
  | 'scheme-feedback-warning-color'
  | 'scheme-feedback-warning-light-color'
  | 'scheme-feedback-forbidden-button-color'
  | 'scheme-toggleitem-selected-title-color'
  | 'scheme-toggleitem-disabled-color';

const mapping: Record<IconColor, SchemeColor> = {
  action: 'scheme-feedback-action-color',
  'action-light': 'scheme-feedback-action-light-color',
  error: 'scheme-feedback-error-color',
  'error-light': 'scheme-feedback-error-light-color',
  regular: 'scheme-feedback-text-color',
  success: 'scheme-feedback-success-color',
  'success-light': 'scheme-feedback-success-light-color',
  warning: 'scheme-feedback-warning-color',
  'warning-light': 'scheme-feedback-warning-light-color',
  forbidden: 'scheme-feedback-forbidden-button-color',
  selected: 'scheme-toggleitem-selected-title-color',
  disabled: 'scheme-toggleitem-disabled-color',
} as const;

export const getColorVariable = (
  color?: IconColor,
): SchemeColor | undefined => {
  return color ? mapping[color] : undefined;
};
